import angular from "angular";
import _ from "lodash";
import {IFeedService} from "@common/service/feed.service";
import {DocumentFolder, FolderStatusCodes, FolderTypeCodes} from "@common/model/documentFolder";
import {ORDER, RESET_FOLDER_FIELD} from "@common/model/constants";
import {PermissionsEnum, TargetEnum} from "ecv/common/permissions";
import {ViewPortData} from "@common/model/ViewPortData";
import {ITeamPermissionService, TeamPermissionService} from "@common/service/teamPermission.service";
import {FOLDER_MODULES, MODULES, MENU_ACTIONS} from "@common/model/constants";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {CachingService} from "@common/service/caching.service";
import {DocumentFolderService} from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import {PopUpService} from "@common/popup/popup.service";
import {CacheService} from "@common/service/cache.service";
import {DocumentService} from "@common/service/document.service";
import {BroadcastService} from "@common/service/broadcast.service";
import {UserService} from "@common/service/user.service";
import {PermissionService} from "ecv/common/permissions";
import { IAppRootScopeService } from "@/app/app.definition";
import {BreadCrumb} from "@common/model/breadCrumb";


// Controller interface
interface IEcvMainBoard {
    init: Function;
    size: number;
    subject;
    refreshing : boolean;

    displayNewInfoFloater(data, dataChanges);

    updatePostSubject(id: number, action: string);

    updatePostUsers(subjectId, user);

    updateDocumentMetadata(id: number, data: any, updateMetadata: boolean): void;
}

// Directive Controller
class EcvMainBoard implements IEcvMainBoard {
    size: number;
    subject;
    isDesc: boolean;
    sortOrder;
    filterDropdown1;
    filterDropdown2;
    filterDropdown3;
    filterDropdown4;
    folderSort;
    docSort;
    sortOrderTypes;
    additionalPropertiesArr;
    hasSingleSubject;
    listView;
    currentFolderId;
    folderExists;
    currentFolder;
    userDocuments;
    hasFolders;
    hasDocuments;
    MENU_ACTIONS;
    FOLDER_MODULES;
    isSystemFolder;
    initialLoad;
    nothingNew;
    showInfoFloater;
    hasNotificationArray;
    selectedDocs;
    loadingDocuments;
    page;
    displayAs;
    folderModule;
    isDiscAllowed: boolean = true;
    boardData;
    loading;
    pageLoading;
    minHeight;
    ItemTypeEnum;
    cmenuPlacement; // refers to the placement of context menu
    swmFolderId;
    mydocFolderId;
    generalNotification: boolean = true;
    notViewedCount: number;
    itemTopIndex;
    currentUser;
    isNonEnterpriseUser;
    orgTeamsFolder;
    isTeammember: boolean = true;
    isUploadPermited = true;
    isToggleSearch = false;
    keyword: string;
    showFilter: boolean;
    ecvPopoverSelector;
    rlFolderId;
    applyFilterFlag: boolean = false;
    filterFolderId;
    RLNtAvlblMsg;
    moduleRootFolder;
    refreshing: boolean;


    static $inject = ["$filter", '$scope', '$rootScope', '$q', "ApiAdapterService", "FeedService", "CacheService",
        "DocumentFolderService", "$state", "PopUpService", "CachingService",
        "DocumentService", "TeamPermissionService", "$timeout", "BroadcastService", "UserService", "PermissionService"];

    constructor(
        private $filter : angular.IFilterService,
        private $scope : angular.IScope,
        private $rootScope : IAppRootScopeService,
        private $q : angular.IQService,
        private ApiAdapterService : JavaApiAdapterService,
        private $_feed: IFeedService,
        private CacheService : CacheService,
        private $_docFolderSvc : DocumentFolderService,
        private $state : angular.ui.IStateService,
        private PopUpService : PopUpService,
        private $_caching : CachingService,
        private $_document : DocumentService,
        private $_teamPerm : TeamPermissionService,
        private $timeout : angular.ITimeoutService,
        private BroadcastService : BroadcastService,
        private $_user : UserService,
        private PermissionService : PermissionService
    ) {
        this.sortOrderTypes = [
            {id: 1, label: "Date - Created On", dirSortField: "createdAt", docSortField: "activityDate"},
            {id: 2, label: "Date - Updated On", dirSortField: "updatedAt", docSortField: "lastActionTime"},
            {id: 3, label: "Name/Title", dirSortField: "name", docSortField: "title"}
        ];
        $rootScope.mainShowLoader = true;
        this.initialLoad = true;
        this.nothingNew = false;
        this.hasFolders = true;
        this.hasDocuments = true;
        this.MENU_ACTIONS = MENU_ACTIONS;
        this.FOLDER_MODULES = FOLDER_MODULES;
        this.showInfoFloater = false;
        this.hasNotificationArray = [];
        this.currentUser = this.CacheService.getUser();
        this.isNonEnterpriseUser = (this.currentUser.organizationId == 0);
        this.folderSort = $_docFolderSvc.folderSort;
        this.docSort = $_docFolderSvc.docSort;
        this.keyword = "";
        this.showFilter = window.innerWidth > 959;
        if (!this.$state.params.fromSearch) {
            this.CacheService.setPostFilters(null);
        }
        if (!!this.currentFolder && this.currentFolder.subject) {
            this.$_user.isUserTeammember(this.currentFolder.subject).then((s) => {

                this.isTeammember = s;
                if (!s) {
                    this.PermissionService.isActionAllowed(this.currentFolder.subject.teamPartyId, TargetEnum.DOCUMENT, PermissionsEnum.CREATE).then((isPermited) => {
                        this.isUploadPermited = isPermited
                    })

                }
            });
        }

        $_docFolderSvc.folderOperation = ($event : any, operation : string, item : any) => {
            let deferred = this.$q.defer();
            if (operation == this.MENU_ACTIONS.OPEN) {
                if ($event.target.className.includes('stop-click') != true || $event.target.className.includes('action-open') == true) {
                    this.openFolder(item.id);
                }
            } else if (operation == this.MENU_ACTIONS.DELETE) {
                this.$rootScope.mainShowLoader = true;
                this.ApiAdapterService.deleteDocumentFolder(this.currentUser.id, item.id).then((s) => {
                    toastr.success('You have successfully deleted the Folder.');
                    this.$_docFolderSvc.deleteFolder(item.id);
                    this.hasFolders = ((--this.currentFolder.childCount) > 0);
                    let pageNumber = Math.ceil(this.itemTopIndex / this.size);
                    this.refreshViewPort(0, true, pageNumber);
                    if (_.includes([FolderTypeCodes.RESOURCE_LIBRARY, FolderTypeCodes.RESOURCE_LIBRARY_CHILD], this.currentFolder.folderType)) {
                        this.refreshFolderFilterList();
                    }
                    this.BroadcastService.broadcast('update-context-menu', [this.currentFolder.id]);
                }, (e) => {
                    toastr.success(e);
                }).finally(() => {
                    this.$rootScope.mainShowLoader = false;
                });
            } else {
                let docType = !!item ? item.postType : null;
                let folder = (operation == this.MENU_ACTIONS.CREATE) ? this.currentFolder : item;

                this.PopUpService.openFolderOperationsPopup(operation, docType, folder).then(
                    (s) => {
                        if (!!item && !!item.postType && operation != this.MENU_ACTIONS.COPY) {
                            let oldParentId = item.documentFolderId;
                            item.documentFolderId = s.parentId;
                            this.$_docFolderSvc.changeDocumentParent(item);
                            this.postCallBack(null, MENU_ACTIONS.DELETE, item.id);//to refresh cachedFolderFeeds
                            this.openFolder(oldParentId);
                            this.BroadcastService.broadcast('update-context-menu', [s.parentId]);
                        } else if (operation == this.MENU_ACTIONS.MOVE) {
                            let oldParentId = item.parentId;
                            this.$_docFolderSvc.changeFolderParent(oldParentId, s.parentId);
                            if (_.includes([FolderTypeCodes.RESOURCE_LIBRARY, FolderTypeCodes.RESOURCE_LIBRARY_CHILD], this.currentFolder.folderType)) {
                                this.refreshFolderFilterList();
                            }
                            this.openFolder(oldParentId);
                            this.BroadcastService.broadcast('update-context-menu', [s.parentId]);
                        } else if (operation == this.MENU_ACTIONS.CREATE) {
                            this.$_docFolderSvc.updateChildren(this.currentFolder.id);
                            if (_.includes([FolderTypeCodes.RESOURCE_LIBRARY, FolderTypeCodes.RESOURCE_LIBRARY_CHILD], this.currentFolder.folderType)) {
                                this.refreshFolderFilterList();
                            }
                            this.openFolder(s.parentId);
                            this.BroadcastService.broadcast('update-context-menu', [s.parentId]);
                        } else if (operation == this.MENU_ACTIONS.COPY) {
                            this.openFolder(s.parentId);
                            this.BroadcastService.broadcast('update-context-menu', [s.parentId]);
                        } else {
                            if (operation == this.MENU_ACTIONS.RENAME) {
                                s.updatedAt = new Date();
                            }
                            if (_.includes([FolderTypeCodes.RESOURCE_LIBRARY, FolderTypeCodes.RESOURCE_LIBRARY_CHILD], this.currentFolder.folderType)) {
                                this.refreshFolderFilterList();
                            }
                            this.$_docFolderSvc.resetChildren({id: this.currentFolder.id});
                            this.openFolder(s.parentId);
                        }


                        deferred.resolve(s);
                    },
                    (e) => {
                        deferred.reject(e);
                        console.log(e);
                    });
            }
            return deferred.promise;
        }
        this.ItemTypeEnum = this.$_docFolderSvc.ItemTypeEnum;
        var resizeFunc = () => {
            if (window.innerWidth > 959) {
                this.showHideFilter(true);
            }
            subsribeScroll();
        };
        $(window).on('resize', resizeFunc);

        function subsribeScroll() {
            $('.md-virtual-repeat-scroller').on('scroll', function () {
                if ($('.md-virtual-repeat-scroller').scrollTop() >= 105) {
                    $('#rightPanel , #filterIcon').addClass("stickytop");
                } else {
                    $('#rightPanel , #filterIcon').removeClass('stickytop');
                }
            });
        }

        function unSubscribeScroll() {
            $('.md-virtual-repeat-scroller').off('scroll');
        }

        subsribeScroll();
        $scope.$on('$destroy', function () {
            BroadcastService.removeCallBack('cr-selected', $scope.$id);
            BroadcastService.removeCallBack('new-document', $scope.$id);
            BroadcastService.removeCallBack('document-uploaded', $scope.$id);
            BroadcastService.removeCallBack('link-uploaded', $scope.$id);
            BroadcastService.removeCallBack('folder-document-updates', $scope.$id);
            BroadcastService.removeCallBack('update-document-metadata', $scope.$id);
            BroadcastService.removeCallBack('team-updates', $scope.$id);
            BroadcastService.removeCallBack('doc-user-updates', $scope.$id);
            BroadcastService.removeCallBack('docdis-newinfo-clicked', $scope.$id);
            BroadcastService.removeCallBack('update-notification-array', $scope.$id);
            BroadcastService.removeCallBack('document-failed', $scope.$id);
            BroadcastService.removeCallBack('viewed-count-updated', $scope.$id);
            BroadcastService.removeCallBack('document-del-updates', $scope.$id);
            //On page change remove the failed entries from cached feeds
            $_feed.removeFailedDocsFeeds();
            $_caching.removeFailedDocs();
            //remove the resize handler and scroll handler
            $(window).off('resize', resizeFunc);
            unSubscribeScroll();
        });
    }

    setNotViewedCount = () => {
        if (this.isNonEnterpriseUser) {
            let sbjCnt = 1; //default true
            this.notViewedCount = this.$_document.getNotViewedCnt(this.folderModule, null);
            if (!!this.subject) {
                sbjCnt = this.$_document.getNotViewedCnt(this.folderModule, this.subject.subjectId);
            }
            this.generalNotification = (sbjCnt > 0);
        }
    }

    //On reset filter i.e Clear button reset all dropdowns,sort and search
    resetFilters = () => {
        //If the user is in mobile view then on click of search filer pop up should be closed
        this.showFilter = window.innerWidth > 959;
        this.clearDropdown(1);
        this.resetSearch();
        this.sortOrder = this.sortOrderTypes[1];
        this.folderSort['sortBy'] = this.sortOrder.dirSortField;
        this.folderSort['sortOrder'] = (this.isDesc ? ORDER.DESC : ORDER.ASC);
        this.docSort['sortBy'] = this.sortOrder.docSortField;
        this.docSort['sortOrder'] = this.folderSort['sortOrder'];
        this.$_docFolderSvc.resetFolders(this.CacheService.getRlFolderId()).then(s => {
            this.$_caching.resetCachedFolderFeeds();
        });
        this.openFolder(this.CacheService.getRlFolderId());
    }

    //Clear the dropdown and its child dropdowns respectively
    clearDropdown(id: number) {
        for (let i = id; i <= 4; i++) {
            this[`filterDropdown${i}`] = null;
        }
        this.compareChangeOfFilter();
    }

    compareChangeOfFilter = () => {
        let filtersFromCache = this.CacheService.getPostFilters();
        let currentFilters = [this.filterDropdown4, this.filterDropdown3, this.filterDropdown2, this.filterDropdown1];
        filtersFromCache = filtersFromCache || [null, null, null, null];
        this.applyFilterFlag = _.isEqual(filtersFromCache, currentFilters);
    }

    //On apply filter get the latest filter details
    applyFilter = () => {
        this.applyFilterFlag = true;
        //If the user is in mobile view then on click of search filer pop up should be closed
        this.showFilter = window.innerWidth > 959;
        let dropdowns = [this.filterDropdown4, this.filterDropdown3, this.filterDropdown2, this.filterDropdown1];
        let firstNonNullDropdown = dropdowns.find(dropdown => dropdown !== null);
        this.CacheService.setPostFilters(dropdowns);
        if (!firstNonNullDropdown) {
            firstNonNullDropdown = this.CacheService.getRlFolderId();
        }
        if (firstNonNullDropdown) {
            //if user is on search results and then applies filter then update the search results
            //else open folder
            if (this.$rootScope.searchResults) {
                this.filterFolderId = firstNonNullDropdown;
                let subjectId;
                if (!!this.subject) {
                    subjectId = this.subject.subjectId;
                }
                if (this.filterFolderId) {
                    this.$rootScope.mainShowLoader = true;
                    //update the breadcrumb according to filter
                    this.$_docFolderSvc.fetchFolderContents(this.filterFolderId, subjectId, this.folderSort).then((s) => {
                        this.$_docFolderSvc.createBreadcrumb(this.filterFolderId, this.folderModule).then((breadcrumbs) => {
                            this.currentFolder.breadcrumb = breadcrumbs;
                            //when the search text is changed broadcast to update the search results
                            this.BroadcastService.broadcast('update-post-search-results', [this.filterFolderId]);
                        });
                    });
                }
            } else {
                this.openFolder(firstNonNullDropdown, false, true);
            }
        }

    }

    refreshFolderFilterList = (orgId?) => {
        //Call the folder list api
        this.ApiAdapterService.getRLFoldersFilter(orgId || this.currentFolder.orgId).then(
            (s) => {
                let folderList = s;
                folderList.sort((a, b) => a.name.localeCompare(b.name));
                this.$_docFolderSvc.folderFilterList = folderList;
                this.$rootScope.showChatbot = true;
            }
        );
    }

    setDocProperties = (docs) => {
        for (let additionalProp of this.additionalPropertiesArr) {
            let post = docs.find(d => d.id == additionalProp.id);
            if (!!post) {
                post.additionalProperties = additionalProp;
            }
        }
        docs.forEach((d) => {
            d.type = this.ItemTypeEnum.DOCUMENT_OR_DISCUSSION;
        });
        this.userDocuments = this.userDocuments.concat(docs);
        return docs;
    }

    getDocuments = (pageNumber, po, itemPadding, isAdjusted) => {
        var deferred = this.$q.defer();
        let subjectId = !!this.subject ? this.subject.subjectId : null;
        var obj = this.boardData.getPageStartEndIndexes(pageNumber, po, itemPadding, isAdjusted);

        var cachedFeed = this.$_caching.getCachedFolderFeedsById(this.currentFolderId);
        if (cachedFeed.length >= obj.endIndex) {
            let posts = cachedFeed.slice(obj.startIndex, obj.endIndex);
            this.$_caching.getDiscussionObjects(posts).then(res => {
                deferred.resolve(this.setDocProperties(res));
            });
        } else {
            this.$_docFolderSvc.fetchChildDocs(this.currentFolderId, subjectId, this.docSort, pageNumber - po, obj.pageSize).then(data => {
                let posts = this.$_caching.getCachedFolderFeedsById(this.currentFolderId).slice(obj.startIndex, obj.endIndex);
                this.$_caching.getDiscussionObjects(posts).then(res => {
                    deferred.resolve(this.setDocProperties(res));
                });
            });
        }
        return deferred.promise;
    }

    sortOrderChanged = (reload = true) => {
        if (reload) {
            this.$_docFolderSvc.resetFolders(this.currentFolder.id).then(s => {
                var totalDoc = this.currentFolder.childDocCount;
                var totalfolder = this.currentFolder.childCount;
                this.userDocuments = [];
                this.$_caching.resetCachedFolderFeeds();
                this.checkForFolderReset();
                this.itemTopIndex = 0;
                if (totalDoc > 0 || totalfolder > 0) {
                    this.boardData.refreshViewPortData({}, 0, totalfolder + totalDoc);
                } else {
                    this.loading = false;
                }
            });
        }
    }

    setFolderContents = (folderId, subjectId, initVPLoading = true) => {
        var deferred = this.$q.defer();
        this.fixCachedDoc(folderId);
        this.$_docFolderSvc.fetchFolderContents(folderId, subjectId, this.folderSort).then((s) => {
            this.currentFolder = s;
            this.currentFolder.disableNewFolder = true;
            this.$_docFolderSvc.createBreadcrumb(folderId, this.folderModule).then((breadcrumbs : BreadCrumb[]) => {
                this.currentFolder.breadcrumb = breadcrumbs;
                this.isToggleSearch = _.includes([FolderTypeCodes.RESOURCE_LIBRARY, FolderTypeCodes.RESOURCE_LIBRARY_CHILD], this.currentFolder.folderType);
                // Set the position of the right div beside the left div
                this.$_document.SubScribeTopPosition("leftPanel", "rightPanel", ".doclisting .md-virtual-repeat-scroller");
                if (this.currentFolder.folderType === FolderTypeCodes.RESOURCE_LIBRARY || this.currentFolder.folderType === FolderTypeCodes.RESOURCE_LIBRARY_CHILD) {
                    if (this.currentFolder.folderType == FolderTypeCodes.RESOURCE_LIBRARY) {
                        this.CacheService.setRlFolderId(this.currentFolderId);
                    }
                    //if RL folder is not cached and user comes to its child folder directly
                    //then take RL folder id from breadcrumb
                    if (breadcrumbs && this.CacheService.getRlFolderId() == null) {
                        let rlFolder = breadcrumbs.find(obj => obj.name === "Resource library");
                        this.CacheService.setRlFolderId(rlFolder.id);
                    }
                    

                    this.PermissionService.isActionAllowed(this.currentUser.partyId, TargetEnum.RESOURCE_LIBRARY_DOCUMENT, PermissionsEnum.CREATE).then((value) => {
                        this.currentFolder.disableNewEntity = !value;
                        this.isUploadPermited = value;
                    })
                    this.PermissionService.isActionAllowed(this.currentUser.partyId, TargetEnum.RESOURCE_LIBRARY_CHILDFOLDER, PermissionsEnum.CREATE).then((value) => {
                        this.currentFolder.disableNewFolder = !value
                    })
                } else {
                    this.currentFolder.disableNewEntity = !this.$_docFolderSvc.isActionAllowed(this.currentFolder.allowedOperation, FolderStatusCodes.DOC_UPLOAD);
                    this.currentFolder.disableNewFolder = !this.$_docFolderSvc.isTeamMember(this.$_docFolderSvc.isActionAllowed(this.currentFolder.allowedOperation, FolderStatusCodes.SUB_FOLDER_CREATE), this.currentFolder);
                }
                this.hasFolders = (this.currentFolder.childCount > 0);
                this.isSystemFolder = (this.currentFolder.parentId != 0 && this.currentFolder.folderType == FolderTypeCodes.SYSTEM);
                this.hasDocuments = (this.currentFolder.childDocCount > 0);

                this.sortOrderChanged(false);
                this.$timeout(() => {
                    if (initVPLoading && (this.hasDocuments || this.hasFolders)) {
                        this.refreshViewPort(0, false);
                    } else {
                        this.$rootScope.mainShowLoader = false;
                    }
                }, 0);

                deferred.resolve();
            });
        });
        return deferred.promise;
    }

    initVPLoading = (numItems) => {
        var folderPageData, itemPadding = 0, pageOffset = 0, isGvw = !this.listView;
        var loading = {};
        var gridItemSize = 1;
        if (isGvw) {
            var width = window.innerWidth;
            if (width >= 1200) {
                gridItemSize = 6;

            } else if (width >= 992) {
                gridItemSize = 4;
            } else if (width >= 768) {
                gridItemSize = 3;
            } else {
                gridItemSize = 2;
            }
        }
        this.$_docFolderSvc.gridItemSize = gridItemSize;
        var totalDoc = this.currentFolder.childDocCount;
        var totalfolder = this.currentFolder.childCount;
        if (this.hasFolders) {
            folderPageData = new ViewPortData({}, 0, this.size, totalfolder, gridItemSize);
            itemPadding = folderPageData.itemPadding;
            pageOffset = (itemPadding == 0) ? folderPageData.totalPages : (folderPageData.totalPages - 1);

        }
        //iniitalize view port data loading
        if (!!this.userDocuments)
            this.userDocuments.splice(0, this.userDocuments.length);
        else
            this.userDocuments = [];
        this.boardData = new ViewPortData({}, numItems, this.size, (totalDoc + totalfolder), gridItemSize);

        this.boardData.fetchPage = (pageNumber) => {
            var deferred = this.$q.defer();
            var folders = [], subjId;
            if (!!this.subject) {
                subjId = this.subject.subjectId;
            }
            if (pageNumber > 0 && (!this.boardData.loadedPages[pageNumber - 1] || !!loading[pageNumber])) {
                //if previous page is not loaded yet then wait for that
                return;
            }
            loading[pageNumber] = true;
            this.pageLoading = true;
            // Set the page to null so we know it is already being fetched.
            this.boardData.loadedPages[pageNumber] = null;
            if (pageNumber == 0 && !!this.currentFolder.teamShortcut) {
                folders.push(this.currentFolder.teamShortcut);
            }
            if (pageNumber > 1) {
                this.loading = true;
            }
            var loadingCompleted = (count) => {
                this.updateDocumentProps();
                this.$timeout(() => {
                    this.loading = false;
                    loading[pageNumber] = false;
                    this.pageLoading = (<any>Object).values(loading).includes(true);
                    this.$rootScope.mainShowLoader = false;
                    this.$timeout(() => {
                        this.boardData.numItems += count;
                        this.refreshing = false;
                    }, 500);
                }, 100);
            };
            var getMappedVal = function (data) {
                if (!isGvw) {
                    return data.map(function (d) {
                        return [d]
                    });
                } else {
                    var arr = []
                    var n = Math.floor(data.length / gridItemSize);
                    var modulo = data.length % gridItemSize;
                    for (var i = 0; i < n; i++) {
                        arr.push(data.slice(i * gridItemSize, (i + 1) * gridItemSize));
                    }
                    if (modulo > 0) {
                        arr.push(data.slice(i * gridItemSize, (i * gridItemSize) + modulo));
                    }
                    return arr;
                }
            }

            if (this.hasFolders && pageNumber < folderPageData.totalPages) {
                var obj = folderPageData.getPageStartEndIndexes(pageNumber);
                this.$_docFolderSvc.fetchChildFolders(this.currentFolder.id, this.folderSort, subjId, obj.startIndex, obj.endIndex).then((f) => {
                    folders = folders.concat(f);
                    if ((folderPageData.totalPages - 1) > pageNumber || folderPageData.itemPadding == 0) {
                        this.boardData.loadedPages[pageNumber] = getMappedVal(folders);
                        loadingCompleted(folders.length);
                        deferred.resolve();
                    } else {
                        this.getDocuments(pageNumber, pageOffset, itemPadding, true).then((docs) => {
                            folders = folders.concat(docs);
                            this.boardData.loadedPages[pageNumber] = getMappedVal(folders);
                            loadingCompleted(folders.length);
                            deferred.resolve();
                        });
                    }
                })
            } else if (pageNumber < this.boardData.totalPages) {
                var currentFolderId = this.currentFolder.id;
                this.getDocuments(pageNumber, pageOffset, itemPadding, false).then((docs) => {
                    folders = folders.concat(docs);
                    if (this.currentFolder.id == currentFolderId) {
                        this.boardData.loadedPages[pageNumber] = getMappedVal(folders);
                    }
                    loadingCompleted(folders.length);
                    deferred.resolve();
                });
            } else {
                this.loading = false;
                loading[pageNumber] = false;
                this.pageLoading = (<any>Object).values(loading).includes(true);
            }
            return deferred.promise;
        };
    };

    fixCachedDoc = (folderId) => {
        let cachedFeed = this.$_caching.getCachedFolderFeeds();
        const currentCachedFeed = this.$_caching.getCachedFolderFeedsById(folderId);
        const fixedLen = currentCachedFeed.length - (currentCachedFeed.length % this.size);
        cachedFeed[this.currentFolderId] = currentCachedFeed.slice(0, fixedLen);
        this.$_caching.saveCachedFolderFeeds(cachedFeed);
    }

    setForResetFolder = () => {
        this.$_caching.setForFolderReset(RESET_FOLDER_FIELD.SORT, true);
    }

    init = () => {
        this.$rootScope.searchResults = false;
        this.$_user.getOrgSchools();
        var initializeFolders = (folderId) => {
            this.currentFolderId = folderId;
            let folder = this.$_docFolderSvc.fetchFolderById(this.currentFolderId);
            if (!folder) {
                this.folderExists = false;
                this.$rootScope.mainShowLoader = false;
            } else {
                //Added subjectId check for back button scenarios like WEB-13624
                //check for resource lib permission
                if (!!subjectId && !!folder.subjectId && subjectId != folder.subjectId) {
                    folder = this.orgTeamsFolder;
                    folderId = folder.id;
                    this.$state.go('.', {folderId: folderId}, {notify: false});
                }
                this.userDocuments = [];
                this.setFolderContents(folderId, subjectId, true).then((s) => {
                    this.swmFolderId = this.$_docFolderSvc.fetchSharedWithMeFolderId();
                    if (folderId == this.swmFolderId) {
                        this.$_document.updateEntityViewed(this.folderModule);
                    } else if (folderId == this.mydocFolderId) {
                        this.setNotViewedCount();
                    }

                    if (this.$state.params.fromSearch) {
                        this.$rootScope.searchResults = true;
                        this.keyword = this.CacheService.getPostSearchResultsDetails().searchText;
                        let dropdowns = this.CacheService.getPostFilters();
                        let firstNonNullDropdown;
                        if (dropdowns) {
                            this.filterDropdown4 = dropdowns[0];
                            this.filterDropdown3 = dropdowns[1];
                            this.filterDropdown2 = dropdowns[2];
                            this.filterDropdown1 = dropdowns[3];
                            firstNonNullDropdown = dropdowns.find(dropdown => dropdown !== null);
                        }

                        this.filterFolderId = firstNonNullDropdown || this.CacheService.getRlFolderId();
                    }
                });
            }
        }
        let subjectId = null;
        this.notViewedCount = 0;
        this.displayAs = (this.page == "Documents") ? "document" : "discussion";
        this.folderModule = (this.page == "Documents") ? (this.$state.includes('list-rl') ? FOLDER_MODULES.RESOURCE_LIBRARY : FOLDER_MODULES.DOCUMENT) : FOLDER_MODULES.DISCUSSION;
        let listView = this.CacheService.isListView(this.folderModule);
        // initialise default sorting parameters
        this.isDesc = true; // default sort order is updation date descending
        this.sortOrder = this.sortOrderTypes[1];
        this.folderSort['sortBy'] = this.sortOrder.dirSortField;
        this.folderSort['sortOrder'] = (this.isDesc ? ORDER.DESC : ORDER.ASC);
        this.docSort['sortBy'] = this.sortOrder.docSortField;
        this.docSort['sortOrder'] = this.folderSort['sortOrder'];
        this.$_caching.resetCachedFolderFeeds();
        this.clearDropdown(1)
        this.setForResetFolder();
        ////////////////////
        this.additionalPropertiesArr = [];
        this.hasSingleSubject = this.CacheService.hasSingleSubject();
        if (!!this.subject) {
            subjectId = this.subject.subjectId;
            this.isDiscAllowed = this.$_teamPerm.isModuleAllowedForTeam(this.subject, MODULES.DISCUSSION);
            this.$_user.isUserTeammember(this.subject).then((s) => {
                this.isTeammember = s
            });
        }
        if (typeof listView == 'undefined') {
            listView = true;
        }

        this.setListView(listView, true);
        this.$_docFolderSvc.init(this.folderModule, true).then((s) => {
            let folderId = this.$state.params.folderId;
            this.moduleRootFolder = this.$_docFolderSvc.fetchRootFolder();
            if (this.moduleRootFolder) {
                this.RLNtAvlblMsg = null;
                this.mydocFolderId = this.moduleRootFolder.id;
                this.orgTeamsFolder = this.$_docFolderSvc.fetchFolderByFolderType(FolderTypeCodes.ENTERPRISE_TEAMS);
                //Set initially folder filter list
                if (this.folderModule == FOLDER_MODULES.RESOURCE_LIBRARY && (this.$_docFolderSvc.folderFilterList == null || this.$_docFolderSvc.folderFilterList.length == 0)) {
                    this.refreshFolderFilterList(this.moduleRootFolder.orgId);
                }
                if (!this.isNonEnterpriseUser && !!this.$state.params.subjectId) {
                    this.$_docFolderSvc.fetchSubjectFolder(this.$state.params.subjectId).then((sub) => {
                        folderId = sub.id;
                        let folderOrgId : number = sub.orgId;
                        this.$state.go('.', {folderId: folderId, subjectId: null}, {notify: false});
                        initializeFolders(folderId);
                    });
                } else {
                    if (folderId == "") {
                        folderId = this.mydocFolderId;
                    }
                    initializeFolders(folderId);
                }
            } else {
                if (this.folderModule == FOLDER_MODULES.RESOURCE_LIBRARY) {
                    this.RLNtAvlblMsg = !this.subject ? "Resource Library is not available. Please select a Care Org team to view Resource Library for that organization." : "Resource Library is not available for this team.";
                }
                this.$rootScope.mainShowLoader = false;
            }
        });

        this.BroadcastService.registerCallBack('cr-selected', this.$scope.$id, () => {
            // Whenever subject is changed
            // reset the org teams folder and
            // enterprise org folder and root folder for resource folder
            // so that the child folders can be fetched from backend
            this.$_docFolderSvc.resetChildren({folderType: FolderTypeCodes.ENTERPRISE_TEAMS});
            this.$_docFolderSvc.resetChildren({folderType: FolderTypeCodes.ENTERPRISE});
            this.$_docFolderSvc.resetChildren({folderType: FolderTypeCodes.ROOT});
        });
        this.BroadcastService.registerCallBack('new-document', this.$scope.$id, (data) => {
            this.newPost(data);
        });
        this.BroadcastService.registerCallBack('document-uploaded', this.$scope.$id, (data) => {
            this.postUploaded(data);
        });
        this.BroadcastService.registerCallBack('link-uploaded', this.$scope.$id, (data) => {
            this.linkPostUploaded(data);
        });
        this.BroadcastService.registerCallBack('folder-document-updates', this.$scope.$id, (data, dataChanges) => {
            this.displayNewInfoFloater(data, dataChanges);
        });
        this.BroadcastService.registerCallBack('update-document-metadata', this.$scope.$id, (id, data, updateMetadata) => {
            this.updateDocumentMetadata(id, data, updateMetadata);
        });
        this.BroadcastService.registerCallBack('team-updates', this.$scope.$id, (id, action) => {
            this.updatePostSubject(id, action);
        });
        this.BroadcastService.registerCallBack('doc-user-updates', this.$scope.$id, (subjectId, user) => {
            this.updatePostUsers(subjectId, user);
        });
        this.BroadcastService.registerCallBack('docdis-newinfo-clicked', this.$scope.$id, () => {
            this.updateNewDocInfo();
        });
        this.BroadcastService.registerCallBack('update-notification-array', this.$scope.$id, (data) => {
            this.updateNotiArry(data);
        });
        this.BroadcastService.registerCallBack('document-failed', this.$scope.$id, (data) => {
            this.postFailed(data);
        });
        this.BroadcastService.registerCallBack('viewed-count-updated', this.$scope.$id, () => {
            if (this.currentFolderId == this.mydocFolderId) {
                this.setNotViewedCount();
            } else {
                this.notViewedCount = 0;
            }
        });
        this.BroadcastService.registerCallBack('document-del-updates', this.$scope.$id, (docId) => {
            this.postCallBack(null, MENU_ACTIONS.DELETE, docId);
        });
    }

    updateNotiArry = (id) => {
        this.hasNotificationArray = this.hasNotificationArray.filter(n => n != id);
    }

    linkPostUploaded = (id: number) => {
        this.hasNotificationArray.push(Number(id));
        this.showInfoFloater = true;
    }

    postUploaded = (id: number) => {
        this.hasNotificationArray.push(Number(id));
        let posts = this.$_feed.getCachedFeedIds("documents").filter(d => d.id == id);
        let folderId;
        for (let item of posts) {
            folderId = item.documentFolderId;
            item.failed = false;
            item.uploading = false;
            item.hasNotificationUpdate = true;
        }
        this.$_feed.addOrUpdateCachedFeedIds(posts, "documents", true);
        this.$_feed.addOrUpdateCachedFolderFeedIds(posts, folderId, true).then((modified) => {
            if (this.page.toLowerCase() == "documents" && folderId == this.currentFolderId
                && this.userDocuments.filter(d => d.id === id).length === 0) {
                this.showInfoFloater = true;
            }
        });
    }

    postFailed = (id: number) => {
        let posts = this.userDocuments.filter(d => d.id == id);
        for (let item of posts) {
            item.failed = true;
            item.uploading = true;
        }
    }
    newPost = (id: number) => {
        if (this.currentFolderId == id) {
            this.updateNewDocInfo();
        }
    }

    updateDocumentProps = () => {
        //Select docs for multiplt dwnld
        if (!!this.selectedDocs) {
            for (let doc of this.selectedDocs) {
                let post = this.userDocuments.find(d => d.id == doc.id);
                if (!!post) {
                    post.isSelected = true;
                }
            }
        }

        for (let docId of this.hasNotificationArray) {
            let posts = this.userDocuments.filter(d => d.id == docId);
            for (let p of posts) {
                p.hasNotificationUpdate = true;
            }
        }
    }


    updateNewDocInfo = () => {
        let subjectId;
        if (!!this.subject) {
            subjectId = this.subject.subjectId;
        }
        if (this.currentFolderId == this.swmFolderId) {
            this.$_document.updateEntityViewed(this.folderModule);
        }
        this.setFolderContents(this.currentFolderId, subjectId).then(() => {
                this.resetSearch();
                this.CacheService.setPostFilters(null);
            }
        );

        this.showInfoFloater = false;
    }

    resetSearch() {
        //reset the search text
        this.keyword = "";
        //reset the searchResults variable
        this.$rootScope.searchResults = false;
        this.$state.go('.', {fromSearch: false}, {notify: false});
        //delete the cache
        this.CacheService.setPostSearchResultsDetails(null);
    }

    openFolder = (folderId, calledFromBreadCrumb = false, calledFromApplyFilter = false) => {
        //If it is called from apply filter then no need to reset the filters
        if (!calledFromApplyFilter) {
            this.resetSearch();
            this.CacheService.setPostFilters(null);
            this.clearDropdown(1);
            this.filterFolderId = null;
        }
        if (calledFromBreadCrumb && this.currentFolder.id == folderId) {
            return;
        }

        this.notViewedCount = 0;
        //On folder change remove the failed entries from cached feeds
        this.$_feed.removeFailedDocsFeeds();
        this.$_caching.removeFailedDocs();

        this.$rootScope.mainShowLoader = true;
        if (!!this.userDocuments) {
            this.userDocuments.splice(0, this.userDocuments.length);
        }
        let subjectId;
        this.showInfoFloater = false;
        this.folderExists = true;
        if (!!this.subject) {
            subjectId = this.subject.subjectId;
        }
        if (folderId == "") {
            folderId = this.mydocFolderId;
        }
        this.currentFolderId = folderId;
        this.hasNotificationArray = [];
        this.boardData = null;
        this.setFolderContents(folderId, subjectId).then((s) => {
            this.$state.go('.', {folderId: folderId}, {notify: false});
            this.$rootScope.mainShowLoader = false;
            if (folderId == this.swmFolderId) {
                this.$_document.updateEntityViewed(this.folderModule);
            } else if (folderId == this.mydocFolderId) {
                this.setNotViewedCount();
            }
        });
    }

    reOrder = () => {
        this.isDesc = !this.isDesc;
        this.setSortingOrder();
    };

    checkForFolderReset = () => {
        const _default = this.sortOrderTypes[1];
        const flag = (this.docSort['sortBy'] == _default.docSortField) && (this.docSort['sortOrder'] == ORDER.DESC);
        this.$_caching.setForFolderReset(RESET_FOLDER_FIELD.SORT, flag);
    }

    setSortingOrder = () => {
        this.loading = true;
        this.folderSort['sortBy'] = this.sortOrder.dirSortField;
        this.folderSort['sortOrder'] = (this.isDesc ? ORDER.DESC : ORDER.ASC);
        this.docSort['sortBy'] = this.sortOrder.docSortField;
        this.docSort['sortOrder'] = this.folderSort['sortOrder']
        this.sortOrderChanged();
    };

    getStyle = () => {
        return {
            minHeight: this.minHeight
        };
    };

    search() {
        //If the user is in mobile view then on click of search filer pop up should be closed
        this.showFilter = window.innerWidth > 959;
        //if search keyword is empty then
        //1. if the user is in search results already then redirect to the folder
        //2. if the user is not in search results then disable the button
        if (!this.keyword) {
            if (this.$rootScope.searchResults) {
                this.openFolder(this.currentFolderId);
            }
            return null;
        } else {
            let dropdowns = this.CacheService.getPostFilters();
            let firstNonNullDropdown;
            if (dropdowns) {
                firstNonNullDropdown = dropdowns.find(dropdown => dropdown !== null);
            }
            this.filterFolderId = firstNonNullDropdown || this.CacheService.getRlFolderId();

            this.$_docFolderSvc.createBreadcrumb(this.filterFolderId, this.folderModule)
                .then((breadcrumbs) => {
                    this.currentFolder.breadcrumb = breadcrumbs;
                });

            this.$rootScope.searchResults = true;
            //when the search text or filter is changed broadcast to update the search results
            this.BroadcastService.broadcast('update-post-search-results', [this.filterFolderId]);


        }
    }

    //handle on key press (i.e enter key)
    keyPress(keyEvent: any): void {
        let isEnterKey = keyEvent.which === 13 || keyEvent.charCode === 13;
        if (isEnterKey) {
            if (this.keyword || this.$rootScope.searchResults) {
                keyEvent.preventDefault();
                this.search();
            }
        }
    }

    showHideFilter = (flag: boolean) => {
        this.showFilter = flag;
    }

    refreshViewPort = (numItems, setTopIndex, pageNum = 0) => {
        if (setTopIndex) {
            var index = this.itemTopIndex;
            this.itemTopIndex = undefined;
        } else {
            this.itemTopIndex = 0;
        }

        this.initVPLoading(numItems); // initialize view port loading
        this.$timeout(() => {
            this.boardData.fetchPage(pageNum).then(() => {
                this.$timeout(() => {
                    // when tab reloads we needs to bind the virtual repeater
                    angular.element(window).triggerHandler('resize');
                }, 100);
                if (setTopIndex) {
                    this.$timeout(() => {
                        this.itemTopIndex = index;
                    }, 1000);
                }
            });
        }, 0);
    }

    setListView = (listView: boolean, isCalledFromInit = false) => {
        if (this.listView != listView) {
            const previous = this.refreshing;
            this.refreshing = !isCalledFromInit;
            this.cmenuPlacement = listView ? 'left' : 'auto';
            this.ecvPopoverSelector = '.left-panel';
            this.CacheService.setListViewFlag(this.folderModule, listView);
            this.$_docFolderSvc.viewPortSize = this.size = (listView ? 6 : 2);
            this.listView = listView;
            if (!isCalledFromInit) {
                this.hasFolders = (this.currentFolder.childCount > 0);
                this.hasDocuments = (this.currentFolder.childDocCount > 0);
                if (this.hasFolders || this.hasDocuments) {
                    this.refreshViewPort(0, false);
                } else {
                    this.refreshing = previous;
                }
            }
        }
    }

    postCallBack = (postCntr, action: string, docId) => {
        if (action.toUpperCase() == this.MENU_ACTIONS.DELETE.toUpperCase()) {
            var cachedFeed = this.$_caching.getCachedFolderFeeds();
            var cachedFolderFeed = this.$_caching.getCachedFolderFeedsById(this.currentFolderId);
            cachedFolderFeed = !!cachedFolderFeed ? cachedFolderFeed : [];

            let ind = cachedFolderFeed.findIndex(d => d.id == docId);
            cachedFolderFeed.splice(ind, 1);
            cachedFeed[this.currentFolderId] = cachedFolderFeed;
            this.$_caching.saveCachedFolderFeeds(cachedFeed);

            this.hasDocuments = (this.currentFolder.childDocCount > 0);
            let pageNumber = Math.ceil(this.itemTopIndex / this.size);
            this.refreshViewPort(0, true, pageNumber);
        }
    }

    selectAllTeams = () => {
        this.$rootScope.selectChild(-1).then((s) => {
            this.subject = this.CacheService.getCurrentSubject();
            this.init();
        });
    }

    organize = () => {
        this.$_docFolderSvc.organize(this.currentFolder.id);
    }

    connect = () => {
        this.$_docFolderSvc.connect(this.currentFolder.id);
        return true;
    }

    displayNewInfoFloater = (data, dataChanges) => {
        let ids = data;
        if (!Array.isArray(data)) {
            ids = [data];
        }
        ids = ids.map(Number);

        this.$_feed.getCachedFeedIds(this.page.toLowerCase())
            .filter(doc => (ids.includes(doc.id) && this.currentFolderId == doc.documentFolderId)).forEach(newDoc => {
            this.showInfoFloater = true;
            this.hasNotificationArray.push(Number(newDoc.id));
            if (!!dataChanges) {
                dataChanges.id = newDoc.id;
                this.additionalPropertiesArr.push(dataChanges);
            }
        });
    }

    updateDocumentMetadata(id: number, data: any, updateMetadata: boolean): void {
        var filteredPost = this.userDocuments.find(p => p.id == id);
        if (!!filteredPost) {
            this.$_document.updateDocumentData(filteredPost, data, updateMetadata);
        }
    }

    updatePostSubject(id, action) {
        this.$_document.updateDocState(this.userDocuments, id, action);
    }

    updatePostUsers(subjectId, user) {
        this.$_document.updateDocumentUsers(subjectId, user, this.userDocuments);
    }
}

function mainBoard(): ng.IDirective {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'app/common/itemBoard/components/mainBoard/mainBoard.directive.html',
        replace: true,
        controller: EcvMainBoard,
        controllerAs: 'mBoardVm',
        bindToController: {
            'page': '@',
            'subject': '=',
            'userDocuments': '=',
            'multiSelectMode': '=',
            'selectedDocs': '=',
            'currentFolder': '=',
            'folderExists': '=',
            'loading': '=',
            'showInfoFloater': '=',
            'itemTopIndex': '=',
            'refreshing': "=",
            'listView': '=',
            'isUploadPermited': '=',
            'moduleRootFolder': '=?'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvMainBoard): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.itemBoard').directive('ecvMainBoard', mainBoard);
